import React from 'react';

import {
  AuCallout,
  AuControlInput
} from 'components/DTA';

interface IDeclaration {
  name?: string;
  label: string;
  fullWidth?: boolean;
}

const Declaration: React.FC<IDeclaration> = ({ label, name = 'declaration', children }) => {
  return (
    <AuCallout title='Declaration'>
      {children}
      <AuControlInput name={name} id={`checkbox-${name}`} type='checkbox' label={label} block />
    </AuCallout>
  );
};

export default Declaration;